import Configuration from '@/utils/configuration'

export default {
  data: function () {
    var redirectUrl = Configuration.value('authRedirectUrl')
    var clientId = Configuration.value('authClientId')
    var clientSecret = Configuration.value('authClientSecret')
    var cloudAuthAPIHost = Configuration.value('cloudAuthAPIHost')
    var cloudAuthAPIProtocol = Configuration.value('cloudAuthAPIProtocol')

    return {
      cpAuth: {
        accessTokenUrl: cloudAuthAPIProtocol + '://' + cloudAuthAPIHost + '/token',
        clientId: clientId,
        clientSecret: clientSecret,
        domain: cloudAuthAPIHost,
        redirectUrl: redirectUrl,
        scope: 'read-write',
        responseType: 'code'
      }
    }
  }
}
